import {
  AccountCircle,
  SupervisedUserCircle,
  PhoneIphone,
  AlternateEmail,
  Subject,
  AdsClick,
  Message,
} from '@mui/icons-material';

export default {
  firstName: { type: 'string', Icon: AccountCircle, required: true },
  lastName: { type: 'string', Icon: AccountCircle, required: true },
  nickname: { type: 'string', Icon: SupervisedUserCircle, required: false },
  phoneNumber: { type: 'number', Icon: PhoneIphone, required: false },
  email: { type: 'email', Icon: AlternateEmail, required: true },
  emailVerification: { type: 'email', Icon: AlternateEmail, required: true },
  subject: { type: 'list', Icon: Subject, required: true },
  file: { type: 'file', Icon: AdsClick, required: false },
  message: { type: 'string', Icon: Message, required: true },
};
